var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "rb-promo-toggle",
      class: {
        "rb-promo-toggle--active": _vm.isActive,
        "rb-promo-toggle--loading": _vm.loading,
        "rb-promo-toggle--hover":
          !_vm.loading && !_vm.isActive && _vm.isHover && !_vm.isMobileOrTablet,
      },
      attrs: { type: "button", "aria-label": _vm.ariaLabel },
      on: {
        click: _vm.toggleActiveStatus,
        mouseover: function ($event) {
          _vm.isHover = true
        },
        mouseleave: function ($event) {
          _vm.isHover = false
        },
      },
    },
    [
      _c(
        "span",
        { staticClass: "rb-promo-toggle__icon" },
        [_vm.isActive ? [_vm._t("active")] : [_vm._t("resting")]],
        2
      ),
      _vm._v(" "),
      _vm._t("label"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }